'use client'

import { usePathname } from 'next/navigation'

import AppLinks from './app-links'

const FloatingAppLinks: React.FC = () => {
  const pathname = usePathname()
  const isBrazaPage = pathname.startsWith('/getbraza')

  return isBrazaPage ? (
    <div className="md:flex fixed bottom-[5%] z-50 right-[5%] sm:right-0 left-[5%] md:left-0">
      <AppLinks />
    </div>
  ) : null
}

export default FloatingAppLinks
